import { CirclePlus } from 'lucide-react';
import { useMemo } from 'react';
import { AdminTab } from '.';
import { useAuthentication } from '../../auth';
import { Button } from '../../components/Button';
import { DataTable } from '../../components/DataTable';
import { DialogTrigger } from '../../components/Dialog';
import { TabsList, TabsTrigger } from '../../components/Tabs';
import { useTenantIds } from '../../hooks/useTenantIds';
import { isSuperAdmin } from '../../util/auth';
import { AddClinicDialog } from '../components/AddClinicDialog';
import { useClinicsListColumns } from '../hooks/useClinicsListColumns';

export function ClinicsList() {
  const currentUser = useAuthentication();
  const tenantIds = useTenantIds();
  const columns = useClinicsListColumns();

  const clinics = useMemo(
    () => currentUser?.subtenants?.filter(({ name, inactive }) => inactive || tenantIds?.includes(name)) ?? [],
    [currentUser, tenantIds]
  );

  return (
    <>
      <div className="flex flex-1 flex-col items-center justify-between gap-4 md:flex-row md:gap-0">
        <TabsList className="grid w-full grid-cols-3 md:w-150">
          <TabsTrigger value={AdminTab.Users}>Users</TabsTrigger>
          <TabsTrigger value={AdminTab.Clinics}>Clinics</TabsTrigger>
          <TabsTrigger value={AdminTab.LifeglovLinerStock}>Liner Stock</TabsTrigger>
        </TabsList>

        {isSuperAdmin(currentUser) && (
          <AddClinicDialog>
            <DialogTrigger asChild>
              <Button icon={CirclePlus}>Add Clinic</Button>
            </DialogTrigger>
          </AddClinicDialog>
        )}
      </div>

      <div className="overflow-auto">
        <DataTable
          rows={clinics}
          columns={columns}
          pageSize={15}
          initialSorting={[{ id: 'label', desc: false }]}
          stickyHeader
          autoResetPageIndex={false}
          className="mt-4 min-w-100"
          testId="clinics-list"
        />
      </div>
    </>
  );
}
